import { h } from "@stencil/core";
// import { defaultLayout, layout2, layoutRenders } from "./renders";
import { layout3, layoutRenders, MENU_BAR, TOOLBOX } from "./renders";
import { panelToolbox } from "../../../showcase/assets/components/action-list/models";
import { GXWebModel } from "../../../showcase/assets/components/action-group/models";
export class ChTestFlexibleLayout {
    constructor() {
        this.model = layout3;
        this.designSystem = undefined;
    }
    render() {
        return (h("ch-flexible-layout-render", { key: 'f95ffba2b9c4b4d441ee42401efe0911a97ba4fc', class: "flexible-layout", closeButton: true, contain: "size", dragOutside: true, model: this.model, renders: layoutRenders(this.designSystem), sortable: true }, h("ch-action-group-render", { slot: MENU_BAR, key: MENU_BAR, class: "action-group dropdown dropdown-secondary elevation-2", model: GXWebModel }), h("ch-action-list-render", { slot: TOOLBOX, key: TOOLBOX, class: "list-box list-box-secondary", model: panelToolbox })));
    }
    static get is() { return "ch-test-flexible-layout"; }
    static get originalStyleUrls() {
        return {
            "$": ["test-flexible-layout.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["test-flexible-layout.css"]
        };
    }
    static get properties() {
        return {
            "model": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "FlexibleLayoutModel",
                    "resolved": "Omit<LayoutSplitterModel, \"items\"> & { items: FlexibleLayoutItemModel[]; }",
                    "references": {
                        "FlexibleLayoutModel": {
                            "location": "import",
                            "path": "../../flexible-layout/internal/flexible-layout/types",
                            "id": "src/components/flexible-layout/internal/flexible-layout/types.ts::FlexibleLayoutModel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the distribution of the items in the flexible layout."
                },
                "defaultValue": "layout3"
            },
            "designSystem": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"mercury\" | \"unanimo\"",
                    "resolved": "\"mercury\" | \"unanimo\"",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the design system used. Only for testing purposes."
                },
                "attribute": "design-system",
                "reflect": false
            }
        };
    }
}
